export interface IWatrRequestCounts {
    toDoTotal,
    wageToDoTotal,
    travelToDoTotal,
    pendingDocumentsTotal,
    advancedReimbursementTotal,
    pendingVerifyTotal,
    pendingLWRVerifyTotal,
    pendingDERVerifyTotal,
    pendingPaymentTotal,
    pendingWireTotal,
    paymentErrorTotal,
    pendingSurgeryTotal,
    // pendingReimbursementTotal,
    // pendingTravelReceiptsTotal,
    // pendingTravelReimbursementTotal,
    donated,
    reimbursedTotal,
    notReimbursedTotal,
    pendingRegistrationTotal,
}